<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<fe-header style="z-index: 10000"></fe-header>
<main>
    <fe-card-landing-title
        [title]="'fe_destinations_locations_title' | translate"
        [imageSrc]="'images/banner_empresas_header.jpg' | cdn"
    ></fe-card-landing-title>
    <fe-office-search></fe-office-search>
    <section class="destination__locations__info">
        <div
            class="destination__locations__info__container container py-4 px-0 px-md-4 px-lg-8"
        >
            <div
                class="destination__locations__info__container__top d-flex flex-md-row flex-column py-2 justify-content-between align-items-center"
            >
                <h2
                    class="destination__locations__info__container__top__text m-0"
                >
                    {{ 'fe_destinations_locations_offices_title' | translate }}
                </h2>
                <a
                    [routerLink]="['locations-and-offices' | formatUrl]"
                    fragment="reservationComponent"
                    class="btn__footer py-2"
                    >{{
                        'fe_destinations_locations_offices_button' | translate
                    }}</a
                >
            </div>
            <div class="destination__locations__info__container__bottom pb-4">
                <div
                    class="card border-0 w-100 w-md-auto"
                    (click)="toggleContainer()"
                    [ngClass]="{ 'active-card': isContainerVisible }"
                >
                    <img
                        [src]="'images/north_america.webp' | cdn"
                        alt="North america map"
                        class="card-img-top"
                    />
                    <div class="card-body">
                        <h2>
                            {{
                                'fe_destinations_locations_offices_count_mexico'
                                    | translate
                            }}
                        </h2>
                        <div
                            class="d-flex justify-content-between align-items-center"
                        >
                            <p class="mb-0">
                                {{
                                    'fe_destinations_locations_offices_country'
                                        | translate
                                }}
                            </p>
                            <div class="d-flex align-items-center">
                                <span class="me-2">{{
                                    isContainerVisible
                                        ? ('fe_destinations_locations_offices_hide_button'
                                          | translate)
                                        : ('fe_destinations_locations_offices_show_button'
                                          | translate)
                                }}</span>
                                <img
                                    [src]="
                                        isContainerVisible
                                            ? ('images/chevron-alt-down.png'
                                              | cdn)
                                            : ('images/chevron-down-amarillo.svg'
                                              | cdn)
                                    "
                                    alt="More info icon"
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    *ngIf="isContainerVisible"
                    class="card border-0 w-100 w-md-auto"
                >
                    <div class="card-body second-card-body mb-0">
                        <a [routerLink]="['country' | formatUrl]"
                            >{{
                                'fe_destinations_locations_offices_mexico'
                                    | translate
                            }}
                            ></a
                        >
                        <div
                            class="second-card-body-additional d-flex flex-column justify-content-center align-items-center"
                        >
                            <img
                                [src]="'images/globe-north-america.webp' | cdn"
                                alt="North America"
                            />
                            <p class="m-0">
                                {{
                                    countDestinations?.data?.branchCount ?? 'xx'
                                }}
                            </p>
                            <h2>
                                {{
                                    'fe_destinations_locations_offices_count_mexico'
                                        | translate
                                }}
                            </h2>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <section
        id="reservationComponent"
        class="destination__locations__search mb-16 mb-md-20"
    >
        <div
            class="destination__locations__search__container container py-4 px-0 px-md-4 px-lg-8 d-flex"
        >
            <fe-search-reservation
                class="mb-3 w-100"
                [isNormal]="true"
                [container]="'container-fluid'"
            ></fe-search-reservation>
        </div>
    </section>
</main>
<fe-footer></fe-footer>
